import { ApiService } from '../../api.service';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-rider-rides-requests',
  templateUrl: './rider-rides-requests.component.html',
  styleUrls: ['./rider-rides-requests.component.scss']
})
export class RiderRidesRequestsComponent implements OnInit {

  data1$: any;
  constructor(public api: ApiService, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle('Autoscoop - Mates Ride');
    this.data1$ = this.api.getRequestByUserId();
  }

}
